/**
 * Stoic Knowledge Library — tag taxonomy.
 * Articles carry free-form tags (DB `tags` array / file `tags` array);
 * these groups drive the smart filter chips on /stoic-journal and the
 * quick-add chips in the admin editor. Adding a tag here is enough to
 * make it browsable — chips only render when at least one article uses
 * the tag.
 */

export const TAG_GROUPS = [
  {
    key: "philosophers",
    labelKey: "journal.tags.philosophers",
    tags: ["Marcus Aurelius", "Epictetus", "Seneca", "Musonius Rufus", "Hipparchia", "Zeno"],
  },
  {
    key: "themes",
    labelKey: "journal.tags.themes",
    tags: ["Leadership", "Sales", "Parenting", "Entrepreneurship", "Health", "Relationships", "Finance", "Modern Life"],
  },
  {
    key: "virtues",
    labelKey: "journal.tags.virtues",
    tags: ["Wisdom", "Courage", "Justice", "Temperance"],
  },
  {
    key: "practices",
    labelKey: "journal.tags.practices",
    tags: ["Amor Fati", "Memento Mori", "Dichotomy of Control", "View From Above", "Premeditatio Malorum"],
  },
];

export const normalizeTag = (s) =>
  String(s || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

/** True when an article belongs under a filter slug: matches its category
 *  (legacy behaviour) OR any of its normalized tags (smart library). */
export function articleMatchesFilter(article, slug) {
  if (!slug || slug === "all") return true;
  if (article.category === slug) return true;
  return (article.tags || []).some((t) => normalizeTag(t) === slug);
}

/** Full-text match across title, excerpt, content, author, tags and
 *  category — both languages. Every search term must be present. */
export function articleMatchesQuery(article, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const hay = [
    article.title?.en, article.title?.nl,
    article.excerpt?.en, article.excerpt?.nl,
    article.body?.en, article.body?.nl,
    article.author?.en, article.author?.nl,
    (article.tags || []).join(" "),
    article.category,
    article.articleReference,
  ].filter(Boolean).join(" ").toLowerCase();
  return q.split(/\s+/).every((term) => hay.includes(term));
}
